import { useMutation } from '@apollo/client';
import { Button, Modal } from 'antd';
import React from 'react';
import { DELETE_INSTRUCTION_TYPE } from '../graphql/Mutation';

const DeleteModal = ({
  showModal,
  setShowModal,
  handleRefetch,
  selectedTree,
}) => {
  const handleCancel = () => {
    setShowModal(false);
  };

  const [deleteInstructionType, { loading }] = useMutation(
    DELETE_INSTRUCTION_TYPE,
    {
      onCompleted() {
        handleCancel();
        handleRefetch();
      },
      onError() {},
    },
  );

  const handleDelete = () => {
    deleteInstructionType({
      variables: {
        id: selectedTree?.id,
      },
    });
  };
  return (
    <div id="delete-instruction-type">
      <Modal
        maskClosable={false}
        centered
        open={showModal}
        footer={null}
        closable={false}
        width={420}
        getContainer={() =>
          // eslint-disable-next-line no-undef
          document.getElementById('delete-instruction-type')
        }
      >
        <div>
          <h2>Delete Instruction Type</h2>
          <p>Hey there! </p>
          <p>
            Are you sure you want to delete "{selectedTree?.name}" instruction
            type?
          </p>
          <div className="form-buttons">
            <Button
              shape="round"
              className="cancel-button"
              onClick={handleCancel}
              disabled={loading}
            >
              Cancel
            </Button>
            <Button
              shape="round"
              type="primary"
              className="save-button"
              onClick={handleDelete}
              disabled={loading}
              loading={loading}
            >
              Delete
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default DeleteModal;
